var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2C17.7909 2 16 3.79085 16 6C16 8.20915 17.7909 10 20 10C22.2091 10 24 8.20915 24 6C24 3.79085 22.2091 2 20 2ZM17.5 6C17.5 4.61929 18.6193 3.5 20 3.5C21.3807 3.5 22.5 4.61929 22.5 6C22.5 7.38071 21.3807 8.5 20 8.5C18.6193 8.5 17.5 7.38071 17.5 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4C3.23122 4 2 5.23122 2 6.75V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V12.25C22 11.8358 21.6642 11.5 21.25 11.5C20.8358 11.5 20.5 11.8358 20.5 12.25V17.25C20.5 17.9404 19.9404 18.5 19.25 18.5H4.75C4.05964 18.5 3.5 17.9404 3.5 17.25V10.5119C5.9521 12.0865 8.86997 13 11.9995 13C13.6446 13 15.2322 12.7475 16.7248 12.2786C17.1199 12.1545 17.3397 11.7335 17.2155 11.3383C17.0914 10.9432 16.6704 10.7234 16.2752 10.8476C14.9264 11.2713 13.4904 11.5 11.9995 11.5C8.81313 11.5 5.87292 10.455 3.5 8.68885V6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H13.75C14.1642 5.5 14.5 5.16421 14.5 4.75C14.5 4.33579 14.1642 4 13.75 4H4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotification);
export default __webpack_public_path__ + "static/media/email-notification.438089d1a56f749bde8000081f56da81.svg";
export { ForwardRef as ReactComponent };